const taskInformOptions = [
    { name: 'notification', label: 'Send notification to app', checked: false },
    { name: 'sms', label: 'Send SMS', checked: false }
];

export default taskInformOptions;